<div class="variable-schema-form">
  <!-- Schema title and description -->
  @if (title) {
    <div class="schema-header">
      <div class="schema-title">
        <mat-icon class="title-icon">tune</mat-icon>
        {{ title }}
      </div>
      @if (description) {
        <div class="schema-description">{{ description }}</div>
      }
    </div>
  }

  <!-- Dynamic form fields -->
  <form [formGroup]="form" class="schema-fields">
    @for (field of fields; track field.name) {
      <div class="field-row">

        <!-- String + enum → Select or Radio -->
        @if (field.enumValues) {
          @if (useRadioGroup(field)) {
            <!-- Radio group for ≤4 options -->
            <label class="field-label">
              {{ field.label }}
              @if (field.required) { <span class="required">*</span> }
            </label>
            <mat-radio-group [formControlName]="field.name" color="primary" class="radio-group">
              @for (opt of field.enumValues; track opt; let i = $index) {
                <mat-radio-button [value]="opt">
                  {{ getEnumLabel(field, i) }}
                </mat-radio-button>
              }
            </mat-radio-group>
            @if (field.helpText) {
              <div class="field-hint">{{ field.helpText }}</div>
            }
          } @else {
            <!-- Select dropdown for >4 options -->
            <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
              <mat-label>{{ field.label }}{{ field.required ? ' *' : '' }}</mat-label>
              <mat-select [formControlName]="field.name">
                @for (opt of field.enumValues; track opt; let i = $index) {
                  <mat-option [value]="opt">{{ getEnumLabel(field, i) }}</mat-option>
                }
              </mat-select>
              @if (field.helpText) {
                <mat-hint>{{ field.helpText }}</mat-hint>
              }
              @if (hasError(field)) {
                <mat-error>{{ getError(field) }}</mat-error>
              }
            </mat-form-field>
          }
        }

        <!-- Boolean → Checkbox -->
        @else if (field.type === 'boolean') {
          <mat-checkbox [formControlName]="field.name" color="primary">
            {{ field.label }}
          </mat-checkbox>
          @if (field.helpText) {
            <div class="field-hint checkbox-hint">{{ field.helpText }}</div>
          }
        }

        <!-- String + format:date → Date picker -->
        @else if (field.type === 'string' && field.format === 'date') {
          <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
            <mat-label>{{ field.label }}{{ field.required ? ' *' : '' }}</mat-label>
            <input matInput [matDatepicker]="picker" [formControlName]="field.name"
                   placeholder="YYYY-MM-DD">
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            @if (field.helpText) {
              <mat-hint>{{ field.helpText }}</mat-hint>
            }
            @if (hasError(field)) {
              <mat-error>{{ getError(field) }}</mat-error>
            }
          </mat-form-field>
        }

        <!-- String + textarea widget -->
        @else if (field.type === 'string' && field.widget === 'textarea') {
          <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
            <mat-label>{{ field.label }}{{ field.required ? ' *' : '' }}</mat-label>
            <textarea matInput [formControlName]="field.name" rows="3"></textarea>
            @if (field.helpText) {
              <mat-hint>{{ field.helpText }}</mat-hint>
            }
            @if (hasError(field)) {
              <mat-error>{{ getError(field) }}</mat-error>
            }
          </mat-form-field>
        }

        <!-- Number / Integer -->
        @else if (field.type === 'number' || field.type === 'integer') {
          <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
            <mat-label>{{ field.label }}{{ field.required ? ' *' : '' }}</mat-label>
            <input matInput type="number" [formControlName]="field.name"
                   [attr.min]="field.minimum" [attr.max]="field.maximum"
                   [attr.step]="field.type === 'integer' ? 1 : 'any'">
            @if (field.minimum !== null && field.minimum !== undefined && field.maximum !== null && field.maximum !== undefined) {
              <span matTextSuffix class="range-hint">{{ field.minimum }}–{{ field.maximum }}</span>
            }
            @if (field.helpText) {
              <mat-hint>{{ field.helpText }}</mat-hint>
            }
            @if (hasError(field)) {
              <mat-error>{{ getError(field) }}</mat-error>
            }
          </mat-form-field>
        }

        <!-- Default: String text input -->
        @else {
          <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
            <mat-label>{{ field.label }}{{ field.required ? ' *' : '' }}</mat-label>
            <input matInput [formControlName]="field.name">
            @if (field.helpText) {
              <mat-hint>{{ field.helpText }}</mat-hint>
            }
            @if (hasError(field)) {
              <mat-error>{{ getError(field) }}</mat-error>
            }
          </mat-form-field>
        }

      </div>
    }
  </form>
</div>
